export const URL_PARAM_NAMES = {
  // Dashboard params
  GRANULARITY: 'granularity',
  DATE_RANGE: 'dateRange',
  COMPARE_DATE_RANGE: 'compareDateRange',
  IS_COMPARE: 'isCompare',
  PRESET: 'preset',
  COMPARE_PRESET: 'comparePreset',
  ATTRIBUTION_MODEL: 'attributionModel',
  ATTRIBUTION_WINDOW: 'attributionWindow',
  INCLUDE_TODAY: 'includeToday',
  FILTERS: 'filters',
  VIEW_ID: 'viewId',
  // Attribution params
  DIMENSION: 'dimension',
  DIMENSION_FILTERS: 'dimensionFilters',
  VALUE_SOURCE: 'valueSource',
  IS_SHOPIFY_ATTRIBUTION: 'isShopifyAttribution',
  ATTRIBUTION_EVENT: 'attributionEvent',
} as const;
export const attributionParams = [
  URL_PARAM_NAMES.ATTRIBUTION_WINDOW,
  URL_PARAM_NAMES.ATTRIBUTION_MODEL,
  URL_PARAM_NAMES.DATE_RANGE,
  URL_PARAM_NAMES.GRANULARITY,
  URL_PARAM_NAMES.PRESET,
  URL_PARAM_NAMES.DIMENSION,
  URL_PARAM_NAMES.DIMENSION_FILTERS,
  URL_PARAM_NAMES.VALUE_SOURCE,
  URL_PARAM_NAMES.ATTRIBUTION_EVENT,
] as const;
